(function() { window.GUID_9340d8bb_eb55_449d_b0f9_935c9f150bac = { getGuid: function() { return "9340d8bb-eb55-449d-b0f9-935c9f150bac"; } }; })();
var CS;
(function (CS) {
    class CheckBoxV2 {
        constructor(checkBoxUI, dontBindEvents) {
            this.OnValChanged = function () {
                var me = this;
                if (me.Val()) {
                    if (me.Image.length > 0) {
                        me.Image.show();
                        me.Image[0].src = me.BaseImgUrl + me.CheckedImg;
                    }
                    else {
                        me.ColorMode.removeClass(me.Colors[1]);
                        me.ColorMode.addClass(me.Colors[0]);
                    }
                }
                else {
                    if (me.Image.length > 0) {
                        if (me.UncheckedImg != "") {
                            me.Image[0].src = me.BaseImgUrl + me.UncheckedImg;
                        }
                        else {
                            me.Image.hide();
                        }
                    }
                    else {
                        me.ColorMode.removeClass(me.Colors[0]);
                        me.ColorMode.addClass(me.Colors[1]);
                    }
                }
                $(me.CheckBox).trigger('change', me);
            };
            this.CheckBox = checkBoxUI;
            this.DontBindEvents = dontBindEvents;
            let isReadOnly = false;
            isReadOnly = this.CheckBox.hasClass('IsReadOnly');
            if (isReadOnly) {
                return;
            }
            this.HiddenVal = $('input[type=hidden]', this.CheckBox);
            this.Image = $('img', this.CheckBox);
            this.ColorMode = $('.ColorMode', this.CheckBox);
            if (this.Image.length > 0) {
                var images = this.Image.data("images");
                var splitImages = images.split(",");
                this.BaseImgUrl = splitImages[0];
                this.CheckedImg = splitImages[1];
                this.UncheckedImg = splitImages[2];
                this.ThirdStateImg = splitImages[3];
            }
            else {
                var colors = this.ColorMode.data("colors");
                this.Colors = colors.split(",");
            }
            if (!this.DontBindEvents) {
                this.PrepareEvents();
            }
        }
        PrepareOnChange() {
            var me = this;
        }
        Val(val) {
            var me = this;
            if (typeof (val) == "undefined") {
                if (me.HiddenVal.val().toLowerCase() == "true") {
                    return true;
                }
                else {
                    return false;
                }
            }
            else {
                me.HiddenVal.val(val);
                me.OnValChanged();
            }
        }
        PrepareEvents() {
            var me = this;
            me.CheckBox.on('click', function (e) {
                e.PrepareEvents();
                var newVal = !me.Val();
                me.Val(newVal);
            });
        }
    }
    CS.CheckBoxV2 = CheckBoxV2;
})(CS || (CS = {}));
/*
(function ($) {
    $.fn.CSCheckBoxV2 = function (dontBindEvents) {
        if (dontBindEvents == null)
            dontBindEvents = false;
        this.each(function () {
            var checkBox = new CS.CheckBoxV2($(this, dontBindEvents));
            checkBox.CheckBox.data('context', checkBox);
        });
    };
})(jQuery);
 
CS.CheckBoxV2 = function (me, dontBindEvents) {
    var checkBox = me;
    var me = this;
    me.CheckBox = checkBox;
    me.DontBindEvents = dontBindEvents;

    var isReadOnly = false;
    isReadOnly = me.CheckBox.hasClass('IsReadOnly');
    if (isReadOnly)
        return;

    me.HiddenVal = $('input[type=hidden]', checkBox);
    me.Image = $('img', me.CheckBox);
    me.ColorMode = $('.ColorMode', me.CheckBox);
    if (me.Image.length > 0)
    {
        var images = me.Image.data("images");
        var splitImages = images.split(",");

        me.BaseImgUrl = splitImages[0];
        me.CheckedImg = splitImages[1];
        me.UncheckedImg = splitImages[2];
        me.ThirdStateImg = splitImages[3];
    }
    else {
        var colors = me.ColorMode.data("colors");
        me.Colors = colors.split(",");
    }

    if (me.DontBindEvents)
    {
        me.PrepareEvents();
    }
};

CS.CheckBoxV2.prototype = function () {

    var PrepareOnChange = function () {
        var me = this;

    },
    Val = function (val) {
        var me = this;

        if (typeof (val) == "undefined") {
            if (me.HiddenVal.val().toLowerCase() == "true") {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            me.HiddenVal.val(val);
            me.OnValChanged();
        }
    },
    PrepareEvents = function () {
        var me = this;

        me.CheckBox.on('click', function (e) {
            e.PrepareEvents();
            var newVal = !me.Val();
            me.Val(newVal);
        });
    },
    OnValChanged = function () {
        var me = this;

        if (me.Val()) {
            if (me.Image.length > 0)
            {
                me.Image.show();
                me.Image[0].src = me.BaseImgUrl + me.CheckedImg;
            }
            else
            {
                me.ColorMode.removeClass(me.Colors[1]);
                me.ColorMode.addClass(me.Colors[0]);
            }
        }
        else {
            if (me.Image.length > 0) {
                if (me.UncheckedImg != "") {
                    me.Image[0].src = me.BaseImgUrl + me.UncheckedImg;
                }
                else {
                    me.Image.hide();
                }
            }
            else
            {
                me.ColorMode.removeClass(me.Colors[0]);
                me.ColorMode.addClass(me.Colors[1]);
            }
        }

        $(me.CheckBox).trigger('change', me);

    };
    return {
        PrepareOnChange: PrepareOnChange,
        PrepareEvents: PrepareEvents,
        Val: Val,
        OnValChanged : OnValChanged
    };

}();
*/ 

//# sourceMappingURL=cs.checkboxv2.js.map
